import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ControlErrorsComponent } from './control-errors.component';

@NgModule({
  declarations: [ControlErrorsComponent],
  imports: [CommonModule],
  exports: [ControlErrorsComponent],
})
export class ControlErrorsModule {}
